// /var/www/website2024/192.testproject.work/maracar8/0.8.2/myapp/src/pages/Payment.js

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Sidebar from './Sidebar';
import Header from '../components/Header';
import 'primereact/resources/primereact.css';
import 'primeicons/primeicons.css';
import { Button } from 'primereact/button';
import { API_URLS } from '../api/api.js';
import '../css/button-custom.scss'; // Import the custom button styles here

const Payment = () => {
  const [payments, setPayments] = useState([]); // State to hold the payments data
  const [globalFilter, setGlobalFilter] = useState(""); // State for the global filter
  const [refreshData, setRefreshData] = useState(false);

  useEffect(() => {
    const fetchPayment = async () => {
      const token = localStorage.getItem('token'); // Assume the token is stored in localStorage
      try {
        const response = await axios.get(API_URLS.PAYMENTS_LIST, {
          headers: {
            'Authorization': `Bearer ${token}`, // Use the token for authorization
          },
        });

        // Check if response.data is an array, else set an empty array
        const paymentData = Array.isArray(response.data) ? response.data : [];
        console.log('Fetched payments:', paymentData);
        setPayments(paymentData); // Always set an array

      } catch (error) {
        console.error('There was an error fetching the payment data:', error);
        setPayments([]); // Set empty array on error to avoid issues
      }
    };

    fetchPayment(); // Trigger the data fetching
  }, [refreshData]);



  const bookingIDTemplate = (rowData) => {
    const handleInvoiceNavigation = () => {
      if (rowData.BookingID !== null && rowData.BookingID !== undefined) {
        // Store the BookingID in localStorage if it exists
        localStorage.setItem('localBookingReduxID', rowData.BookingID.toString());
        // Navigate to /payment/invoice in a new tab
        window.open(`/Receipt?BookingID=${rowData.BookingID}`, '_blank');
      } else {
        console.log("BookingID is null or undefined.");
        // Optionally handle the case where BookingID is null or undefined
      }
    };

    if (rowData.BookingID !== null && rowData.BookingID !== undefined) {
      return (
        <Button
          label={rowData.BookingID.toString()}
          icon="pi pi-search"
          className="p-button-raised p-button-rounded p-button-success"
          onClick={handleInvoiceNavigation}
        />
      );
    } else {
      return (
        <span>N/A</span> // Or any other placeholder you prefer
      );
    }
  };

  const handleRefresh = () => {
    setRefreshData(prev => !prev);
  };



  return (
    <div className="dashboard">
      <Sidebar />

      <div className="dashboard-main">
        <Header
          searchQuery={globalFilter}
          setSearchQuery={setGlobalFilter}
          refreshData={handleRefresh}
        />

        <div className="datatable-wrapper">

          <DataTable
            value={payments}
            paginator
            rows={10}
            globalFilter={globalFilter}
            header="Payment List"
            className="p-datatable-details"
            scrollable //
            scrollHeight="flex"
            style={{ width: '100%' }}
          >

            {/* Columns configuration remains unchanged */}
            <Column field="TransactionID" header="Receipt" body={bookingIDTemplate} sortable filter filterPlaceholder="Search by ID" />
            <Column field="TransactionID" header="ID" sortable filter />
            <Column field="CustomerID" header="Customer" sortable filter />
            <Column field="Amount" header="Amount" sortable filter />
            <Column field="Remaining" header="Due" sortable filter />
            <Column field="Currency" header="Currency" sortable filter />
            <Column field="StatusPayment" header="Status" sortable filter />
            <Column field="TransactionDate" header="Date" sortable filter />
            <Column field="TransactionUpdate" header="Date Update" sortable filter />
            <Column field="Notes" header="Notes" sortable filter />
            <Column field="ReferenceNumber" header="Reference" sortable filter />
          </DataTable>

        </div>
      </div>
    </div>
  );
}

export default Payment;
